import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import LazyImage from '../common/LazyImage';
// Import about image
import aboutImage from '../../assets/images/work_examples/photo 15.jpg';
import aboutImageSmall from '../../assets/images/work_examples/photo 15.jpg';

const About = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="section-title centered">
          <h2>About J&C Renovations</h2>
          <p>Dependable Construction Services Serving Central Kentucky</p>
        </div>

        <div className="about-content" ref={ref}>
          <motion.div 
            className="about-image"
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={fadeIn}
            transition={{ duration: 0.6 }}
          >
            <LazyImage 
              src={aboutImage} 
              alt="J&C Renovations team at work"
              placeholderSrc={aboutImageSmall}
            />
          </motion.div>

          <motion.div 
            className="about-text"
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={fadeIn}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p className="lead">
              Proudly serving Waddy, Kentucky and surrounding communities, we bring decades of construction 
              expertise and unwavering reliability to every project.
            </p>
            
            <p>
              Our commitment to excellence, attention to detail, and transparent business practices 
              have made us the trusted choice for clients throughout Spencer County and beyond.
            </p>

            <h3>Why Clients Choose Us:</h3>
            <ul className="about-features">
              <li>
                <span className="feature-icon">✓</span>
                <div>
                  <strong>Proven Reliability</strong>
                  <p>Consistent track record of on-time, on-budget project completion</p>
                </div>
              </li>
              <li>
                <span className="feature-icon">✓</span>
                <div>
                  <strong>Quality Craftsmanship</strong>
                  <p>Meticulous attention to detail in every aspect of construction</p>
                </div>
              </li>
              <li>
                <span className="feature-icon">✓</span>
                <div>
                  <strong>Full Licensing & Insurance</strong>
                  <p>Comprehensive coverage and proper licensing for your protection</p>
                </div>
              </li>
              <li>
                <span className="feature-icon">✓</span>
                <div>
                  <strong>Transparent Communication</strong>
                  <p>Clear, honest communication throughout every project phase</p>
                </div>
              </li>
            </ul>

            <div className="about-cta">
              <a href="#services" className="btn btn-primary">Explore Our Services</a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
